import React, {Fragment} from 'react'
import classNames from 'classnames'

export default function LoadingContainer({
    children,
    isLoading,
    type
}) {

    const Classes = classNames({
        'relative w-full h-full min-h-200 flex items-center justify-center flex-col bg-white bg-opacity-80': true,
    })

    if(isLoading) {
        return (
            <div className={Classes}>
                {!type &&
                    <Fragment>
                        <svg className="animate-spin -ml-1 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-20 stroke-primary" cx="12" cy="12" r="10" strokeWidth="4"></circle>
                            <path className="opacity-100 fill-primary" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                        </svg>
                        <span className='pt-2 text-center uppercase text-sm'>Caricamento...</span>
                    </Fragment>
                }

                {type === 'tiles' &&
                    <div className='w-full py-5'>
                        <div className='flex-1 bg-light rounded-xl animate-pulse p-6 box-border flex gap-3 mb-4'>
                            <div className='w-12 h-12 rounded-full bg-white'/>
                            <div className='flex-1 max-w-500'>
                                <div className='w-full h-2 mt-3 rounded-xl bg-white'/>
                                <div className='w-3/4 h-2 mt-3 rounded-xl bg-white'/>
                            </div>
                        </div>
                        <div className='flex-1 bg-light rounded-xl animate-pulse p-6 box-border flex gap-3'>
                            <div className='w-12 h-12 rounded-full bg-white'/>
                            <div className='flex-1 max-w-500'>
                                <div className='w-full h-2 mt-3 rounded-xl bg-white'/>
                                <div className='w-3/4 h-2 mt-3 rounded-xl bg-white'/>
                            </div>
                        </div>
                    </div>
                }

                {type === 'cards' &&
                    <div className='w-full flex gap-5 py-5'>
                        <div className='flex-1 aspect-video bg-light rounded-xl animate-pulse p-6 box-border flex gap-3'>
                            <div className='w-12 h-12 rounded-full bg-white'/>
                            <div className='flex-1'>
                                <div className='w-full h-2 mt-3 rounded-xl bg-white'/>
                                <div className='w-3/4 h-2 mt-3 rounded-xl bg-white'/>
                            </div>
                        </div>
                        <div className='flex-1 aspect-video bg-light rounded-xl animate-pulse p-6 box-border flex gap-3'>
                            <div className='w-12 h-12 rounded-full bg-white'/>
                            <div className='flex-1'>
                                <div className='w-full h-2 mt-3 rounded-xl bg-white'/>
                                <div className='w-3/4 h-2 mt-3 rounded-xl bg-white'/>
                            </div>
                        </div>
                        <div className='flex-1 aspect-video bg-light rounded-xl animate-pulse p-6 box-border flex gap-3'>
                            <div className='w-12 h-12 rounded-full bg-white'/>
                            <div className='flex-1'>
                                <div className='w-full h-2 mt-3 rounded-xl bg-white'/>
                                <div className='w-3/4 h-2 mt-3 rounded-xl bg-white'/>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }

    return (
        <Fragment>
            {children}
        </Fragment>
    )
}
